import { createContext } from "react";
import type { PropertiesContextValue } from "../types";

export const PropertiesContext = createContext<PropertiesContextValue | null>(null);
